import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import * as Actions from '../../store/actions';
import { bindActionCreators } from 'redux';
import './branches.css';
import { Link } from 'react-router-dom';

import OwlCarousel from 'react-owl-carousel';
import '../../components/Home/home.revelution-slider/slider.css'

export class Branches extends Component {

    componentDidMount() {
        const { updateWording } = this.props;
        updateWording();
    }

    render() {

        const { wording, navbarCategory, currentLanguage, basenameURL } = this.props;

        return (
            <div>
                <section className='pt-70 pb-70' style={{ backgroundColor: '#fff' }}>
                    <h1 className='header-brach black'>BRANCHES</h1>
                    <div className='container relative clearfix' style={{ textAlign: 'center' }}>
                        <ol className='breadcrumb black'>
                            <li>
                                <Link to={`${basenameURL}`}>
                                    {currentLanguage === 'TH'
                                        ? navbarCategory[0]?.categoriesNameTh
                                        : navbarCategory[0]?.categoriesNameEn}
                                </Link>
                            </li>
                            <li>Home</li>
                            <li>branches</li>
                        </ol>
                    </div>
                </section>
                <div className="container">
                    {wording.branchesPage.branch.map((text, num) =>
                        <div className='card-brach mt-50' key={num}>
                            <div className='card-text-brach'>
                                <h2 className='card-text-name'>{text.nameEn}</h2>
                                <h3 className='card-text-floor'>{text.floor}</h3>
                                <b className='card-text-time'>{text.timeEn}</b><br />
                                <br />
                                <b className='card-text-time'>{text.nameTh}</b><br />
                                {
                                    typeof text.detail === "string" 
                                        ? <b className='card-text-detail'>{text.detail}</b>
                                        : (
                                            <b>
                                                <span>{text.detail[0]}</span>
                                                <span className='tablet-br'></span>
                                                <span>{text.detail[1]}</span>
                                            </b>
                                        )
                                }
                                <br />
                                <b className='card-text-time'>{text.timeTh}</b><br />
                            </div>
                            <div className='card-pic-brach background-img' style={{ backgroundImage: 'url(' + text.img + ')' }} />
                        </div>
                    )}
                </div>
                <div style={{ marginTop: '50px' }}>
                    <OwlCarousel
                        className="owl-theme main-slider"
                        items={1}
                        autoplay
                        nav={false}
                        dots
                        loop
                    >
                        {wording.branchesPage.branch.map((img, index) =>
                            <div className='item slide-item' key={`branched-${index}`}>
                                <div
                                    className='slide-image'
                                    style={{ backgroundImage: 'url(' + img.img + ')' }}
                                />
                                <div className='slide-bg' />
                            </div>
                        )}
                    </OwlCarousel>
                </div>
            </div >

        )
    }
}


const mapStateToProps = ({ language, navigation }) => ({
    wording: language.wording,
    navbarCategory: navigation.navbarCategory,
    currentLanguage: language.currentLanguage,
    basenameURL: language.basenameURL
});
const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            updateWording: Actions.updateWording
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Branches);
